import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, TextareaAutosize } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  formContainer: {
    padding: `${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
  },
  requiredField: {
    fontSize: '12px',
    color: '#7D7D7D',
  },
  formControl: {
    width: '100%',
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1.5),
  },
  addNoteItem: {
    borderTop: '1px solid lightgray',
    padding: '8px 16px 16px 0',
  },
}));

const GeneralNoteForm = ({ onSubmit, setSubmitEnabled, onFormReady }) => {
  const classes = useStyles();
  const [note, setNote] = useState('');

  const handleNoteChange = e => {
    const newNote = e.target.value;
    setNote(newNote);
    setSubmitEnabled(newNote.trim().length > 0);
  };

  // Handler for form submission
  const handleFormSubmit = () => {
    const formData = {
      note: note.trim(),
      standardizeNote: false,
    };
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  // Pass submit handler to parent component when form is ready
  useEffect(() => {
    if (onFormReady) {
      onFormReady(handleFormSubmit);
    }
  }, [note]);

  return (
    <Grid container>
      <Grid container className={classes.formContainer}>
        <Grid item xs={12}>
          <Typography className={classes.requiredField}>Write your note here</Typography>
          <TextareaAutosize
            minRows={4}
            value={note}
            onChange={handleNoteChange}
            size="small"
            fullWidth
            className={classes.formControl}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

GeneralNoteForm.propTypes = {
  onSubmit: PropTypes.func,
  setSubmitEnabled: PropTypes.func,
  onFormReady: PropTypes.func,
};

GeneralNoteForm.defaultProps = {
  onSubmit: () => {},
  setSubmitEnabled: () => {},
  onFormReady: undefined,
};

export default GeneralNoteForm;
